module.exports = __webpack_public_path__ + "static/media/cart_icon.49c6f5d7.png";